import { BehaviorSubject, Observable } from 'rxjs';
import { IModelEntity } from '@pit/core';

export interface IEntityStoreFacade<T extends IModelEntity> {

    isLoading?: boolean;
    selectedItem?: T;
    selectedItemId?: number;
    isLoading$?: Observable<boolean>;
    items$?: Observable<T[]>;
    selectedItem$?: Observable<T>;
    selectedItemId$?: Observable<number>;
    updateSubject?: BehaviorSubject<any>;

    getItemById$(id: number): Observable<T>;
    loadItems$(showLoadingIndicator?: boolean): Observable<T[]>;
    loadItemsAsync(showLoadingIndicator?: boolean): Promise<T[]>;
    loadItemsWithPaging(startRow: number, rowsToTake: number, showLoadingIndicator?: boolean): void;
    loadItemById$(id: number, showLoadingIndicator?: boolean): Observable<T>;
    loadItemByIdAsync(id: number): Promise<T>;
    saveItem(item: T, showLoadingIndicator?: boolean): void;
    saveItem$(item: T, showLoadingIndicator?: boolean): Observable<T>;

    saveItemAsync(item: T, showLoadingIndicator?: boolean): Promise<T>;
    selectItem$(item: T): Observable<T>;
    selectItemById$(id: number): Observable<T>;
    upsertItemToStore(item: T): void;
    upsertItemsToStore(items: T[]): void;

}

